import {
  getFromLocalStorage,
  removeFromLocalStorage,
} from "../../../utils/local-storage"

export const segmentIdentifyTraitsKey = "segmentIdentifyTraits"

// Check whether local storage contains values for Segment traits stored by the previous
// page for sending to Segment. Send to Segment and remove if present.
export function sendPersistedSegmentTraits() {
  const persistedSegmentIdentifyTraits = getFromLocalStorage(
    segmentIdentifyTraitsKey,
  )

  if (persistedSegmentIdentifyTraits) {
    window.analytics?.identify(persistedSegmentIdentifyTraits)
    removeFromLocalStorage(segmentIdentifyTraitsKey)
  }
}
